import React from 'react';
import {Field, formValueSelector} from 'redux-form';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

import getDictionaryTranslation from '../../scripts/GetDictionaryTranslation.js';
import * as DateRangeYearOnlyValidation from '../../scripts/DateRangeYearOnlyValidation.js';
import {isProperFormat, isInRange} from '../../scripts/DateRangeValidation.js';

//import components
import AdvancedSearchFormField from './AdvancedSearchFormField.js';
import AdvancedSearchFormSelect from './AdvancedSearchFormSelect.js';
import DateRangeField from '../date-range/DateRangeField.js';

//img
// import binImg from '../../assets/icons/bin.svg';
import binImgLight from '../../assets/icons/bin-light.svg';
import binImgContrast from '../../assets/icons/bin-contrast.svg';
import plusImg from '../../assets/icons/plus.svg';
import plusImgContrast from '../../assets/icons/plus-contrast.svg';

const AdvancedSearchFormFieldset = ({ fields, attributeFieldVal, attributeFieldVals, relationFieldVal, change, meta: { error }, clang, dictionary, getRelation, getAllRelations, conjOptions }) => {
    const addNewField = () => {
        fields.push({
            relation: getRelation(attributeFieldVal),
            connection: conjOptions[0].toUpperCase()
        });
    };

    const removeField = (index) => {
        fields.remove(index);
    };

    const disabledVal = ['IS_EMPTY', 'CONTAINS_ANYTHING'];

    const getInputFieldComponent = (type, query, index) => {
        if (type === 'date') {
            return <div className="advanced-search__box__date">
                      <Field
                          component={DateRangeField}
                          type="text"
                          name={`${query}.valueFrom`}
                          mask="99.99.9999"
                          disabled={disabledVal.includes(relationFieldVal[index])}
                          label={lang[clang].advanced_search.date_from}
                          placeholder={lang[clang].results.date_placeholder}
                          validate={[isProperFormat, isInRange]} />
                      <Field
                          component={DateRangeField}
                          type="text"
                          name={`${query}.valueTo`}
                          mask="99.99.9999"
                          disabled={disabledVal.includes(relationFieldVal[index])}
                          label={lang[clang].advanced_search.date_to}
                          placeholder={lang[clang].results.date_placeholder}
                          validate={[isProperFormat, isInRange]}/>
                  </div>;
        }

        if (type === 'year') {
            return <div className="advanced-search__box__date">
                      <Field
                          component={DateRangeField}
                          type="text"
                          name={`${query}.valueFrom`}
                          mask={'9999'}
                          disabled={disabledVal.includes(relationFieldVal[index])}
                          placeholder={lang[clang].results.year_placeholder}
                          validate={[DateRangeYearOnlyValidation.isInRange]}
                          label={lang[clang].advanced_search.date_from} />
                      <Field
                          component={DateRangeField}
                          type="text"
                          name={`${query}.valueTo`}
                          mask={'9999'}
                          disabled={disabledVal.includes(relationFieldVal[index])}
                          placeholder={lang[clang].results.year_placeholder}
                          validate={[DateRangeYearOnlyValidation.isInRange]}
                          label={lang[clang].advanced_search.date_to} />
                  </div>;
        }

        if (type.includes('dict:')) {
            const dictOptions = attributeFieldVals.map(attr => {
                                    return {
                                      value: attr,
                                      label: getDictionaryTranslation(dictionary, clang, attr, type.split(":")[1])
                                    }
                                });

            return <Field component={AdvancedSearchFormSelect}
                        name={`${query}.value`}
                        label={lang[clang].advanced_search.select_phraze}
                        disabled={disabledVal.includes(relationFieldVal[index])}
                        placeholder={lang[clang].advanced_search.select_phraze}
                        props={{
                            options: dictOptions
                    }}/>;
        }

        return <Field component={AdvancedSearchFormField} type="text"
                  name={`${query}.value`}
                  disabled={disabledVal.includes(relationFieldVal[index])}
                  placeholder={lang[clang].advanced_search.phraze}
                  label={lang[clang].advanced_search.query} />;
    };

    const getNewOptions = (options) => {
        return options.map(option => { return {
                    value: option.toUpperCase(),
                    label: lang[clang].advanced_search.search_field_options[option]
                }});
    };

    const onRelationChange = (val, index) => {
        if (disabledVal.includes(val)) {
            change(`${fields.name}[${index}].valueFrom`, "");
            change(`${fields.name}[${index}].value`, "");
            change(`${fields.name}[${index}].valueTo`, "");
        }
    };

    return (
        <ul className="advanced-search__box--inner__list">
            {fields.map((fieldInner, index) =>
                <li key={index} className="advanced-search__box--inner__list-item">
                    {index !== 0 &&
                        <div className="advanced-search__box--left">
                            <div className="advanced-search__box--left__content">
                                <Field component={AdvancedSearchFormSelect}
                                    name={`${fieldInner}.connection`}
                                    props={{
                                        options: getNewOptions(conjOptions)
                                    }}/>
                            </div>
                        </div>}
                    <div className="advanced-search__box--right">
                        <Field component={AdvancedSearchFormSelect}
                            name={`${fieldInner}.relation`}
                            onChange={(e, newValue) => onRelationChange(newValue, index)}
                            label={lang[clang].advanced_search.relation}
                            props={{
                                options: getNewOptions(getAllRelations(attributeFieldVal))
                            }}/>
                        {getInputFieldComponent(attributeFieldVal, `${fieldInner}`, index)}
                    </div>
                    <div className="advanced-search__box__tools">
                        {fields.length > 1 &&
                            <div className="advanced-search__button--light">
                                <button onClick={() => removeField(index)} type="button"
                                    title={lang[clang].advanced_search.remove_field}>
                                    <img src={binImgLight} className="advanced-search__button--light__img--light contrast" alt="" />
                                    <img src={binImgContrast} className="advanced-search__button--light__img" alt="" />
                                </button>
                            </div>}
                        {index === fields.length - 1 &&
                            <div className="advanced-search__button--dark">
                                <button type="button"
                                    title={lang[clang].advanced_search.add_field}
                                    onClick={() => addNewField()}>
                                    <img src={plusImg} className="advanced-search__button--light__img--light" alt="" />
                                    <img src={plusImgContrast} className="advanced-search__button--light__img contrast" alt="" />
                                </button>
                            </div>}
                        {error && <span>{lang[clang].validation[error]}</span>}
                    </div>
                </li>)}
        </ul>
    );
};

AdvancedSearchFormFieldset.propTypes = {
    clang: propTypes.string.isRequired,
    relationFieldVal: propTypes.arrayOf(propTypes.string).isRequired
};

const mapStateToProps = (state, ownProps) => {
    const selector = formValueSelector(ownProps.meta.form);
    const getFieldSelector = (name) => selector(state, `${name}.relation`);

    return {
        clang: state.language.currentLanguage,
        dictionary: state.language.dictionary,
        //get updated field value from store
        relationFieldVal: ownProps.fields.getAll().map((e, index) => getFieldSelector(`${ownProps.fields.name}[${index}]`))
    }
};

export default connect(mapStateToProps)(AdvancedSearchFormFieldset);



// WEBPACK FOOTER //
// ./src/components/advanced-search/AdvancedSearchFormInnerfield.js